import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  restorePaymentRunReviewAPI,
  type GetPaymentRunReviewParams,
  type RestorePaymentRunReviewParams,
} from '~entities/payment/api/reporting-payment-run-review';
import { QUERY_KEYS } from '~shared/api/query-keys';

export type { RestorePaymentRunReviewParams } from '~entities/payment/api/reporting-payment-run-review';

export interface UseRestorePaymentRunReviewOptions {
  /** When provided, invalidates this report query on success */
  reportParams?: GetPaymentRunReviewParams;
  /** When provided, invalidates the detail query for this invoice/range on success */
  detailParams?: {
    invoiceId: string | null;
    startDate: string;
    endDate: string;
  };
}

export const useRestorePaymentRunReviewMutation = (
  options?: UseRestorePaymentRunReviewOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RestorePaymentRunReviewParams) =>
      restorePaymentRunReviewAPI(params),
    onSuccess: (_data, _variables) => {
      if (options?.reportParams) {
        void queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW(options.reportParams),
        });
      }
      if (options?.detailParams?.invoiceId) {
        void queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW_DETAIL(
            options.detailParams.invoiceId,
            options.detailParams.startDate,
            options.detailParams.endDate,
          ),
        });
      }
    },
  });
};
